// noinspection DuplicatedCode

import {
	base64ToUtf8,
	utf8ToBase64
} from "./data"

import Vue from "vue";

const getStorageKeyName = (key) => {
	return key;
}

const parseValue = (value, base64, json) => {
	if (value == null) {
		return value
	}

	let parse = value
	if (json) {
		parse = JSON.stringify(parse)
	}
	if (base64) {
		parse = utf8ToBase64(parse)
	}

	return parse
}

const parseResult = (result, base64, json) => {
	if (result == null) {
		return result
	}

	let parse = result
	if (base64) {
		parse = base64ToUtf8(parse)
	}
	if (json) {
		parse = JSON.parse(parse)
	}

	return parse
}

// ==================== LocalStorage ====================
export const isSupportLocalStorage = () => {
	const supportKey = 'isSupportLocalStorage'
	const supportValue = 'support'
	localStorage.setItem(supportKey, supportValue)
	return localStorage.getItem(supportKey) === supportValue
}

export const putStorage = (key, value, pureKey = false, base64 = true, json = true) => {
	localStorage.setItem(getStorageKeyName(key, pureKey), parseValue(value, base64, json))
}

export const getStorage = (key, pureKey = false, base64 = true, json = true) => {
	return parseResult(localStorage.getItem(getStorageKeyName(key, pureKey)), base64, json)
}

export const removeStorage = (keys, pureKey = false) => {
	if (Array.isArray(keys)) {
		keys.forEach(key => {
			localStorage.removeItem(getStorageKeyName(key, pureKey))
		})
	} else {
		localStorage.removeItem(getStorageKeyName(keys, pureKey))
	}
}
// ==================== LocalStorage ====================


// ==================== SessionStorage ====================
export const isSupportSessionStorage = () => {
	const supportKey = 'isSupportSessionStorage'
	const supportValue = 'support'
	sessionStorage.setItem(supportKey, supportValue)
	return sessionStorage.getItem(supportKey) === supportValue
}

export const putSession = (key, value, pureKey = false, base64 = true, json = true) => {
	sessionStorage.setItem(getStorageKeyName(key, pureKey), parseValue(value, base64, json))
}

export const getSession = (key, pureKey = false, base64 = true, json = true) => {
	return parseResult(sessionStorage.getItem(getStorageKeyName(key, pureKey)), base64, json)
}

export const removeSession = (keys, pureKey = false) => {
	if (Array.isArray(keys)) {
		keys.forEach(key => {
			sessionStorage.removeItem(getStorageKeyName(key, pureKey))
		})
	} else {
		sessionStorage.removeItem(getStorageKeyName(keys, pureKey))
	}
}
// ==================== SessionStorage ====================


// ==================== Cookie ====================
export const putCookie = (key, value, pureKey = false, base64 = true, json = true) => {
	const exp = new Date()
	exp.setTime(exp.getTime() + 8 * 60 * 1000)

	document.cookie = getStorageKeyName(key, pureKey) + "=" + parseValue(value, base64, json) + ";expires=" + exp
		.toGMTString()
}

export const getCookie = (key, pureKey = false, base64 = true, json = true) => {
	const cookies = document.cookie.split(';')
	const name = getStorageKeyName(key, pureKey) + '='
	for (let i = 0; i < cookies.length; i++) {
		const c = cookies[i].trim()
		if (c.indexOf(name) === 0) {
			return parseResult(c.substring(name.length, c.length), base64, json)
		}
	}
	return null
}

export const removeCookie = (keys, pureKey = false) => {
	if (Array.isArray(keys)) {
		keys.forEach(key => {
			document.cookie = getStorageKeyName(key, pureKey) + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
		})
	} else {
		document.cookie = getStorageKeyName(keys, pureKey) + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"
	}
}
// ==================== Cookie ====================


// ==================== LocalStorage(Cookie) ====================
export const putStorageAuto = (key, value, pureKey = false, base64 = true, json = true) => {
	if (isSupportLocalStorage()) {
		putStorage(key, value, pureKey, base64, json)
	} else {
		putCookie(key, value, pureKey, base64, json)
	}
}

export const getStorageAuto = (key, pureKey = false, base64 = true, json = true) => {
	if (isSupportLocalStorage()) {
		return getStorage(key, pureKey, base64, json)
	} else {
		return getCookie(key, pureKey, base64, json)
	}
}

export const removeStorageAuto = (keys, pureKey = false) => {
	if (isSupportLocalStorage()) {
		removeStorage(keys, pureKey)
	} else {
		removeCookie(keys, pureKey)
	}
}
// ==================== LocalStorage(Cookie) ====================


// ==================== SessionStorage(Cookie) ====================
export const putSessionAuto = (key, value, pureKey = false, base64 = true, json = true) => {
	if (isSupportSessionStorage()) {
		putSession(key, value, pureKey, base64, json)
	} else {
		putCookie(key, value, pureKey, base64, json)
	}
}

export const getSessionAuto = (key, pureKey = false, base64 = true, json = true) => {
	if (isSupportSessionStorage()) {
		return getSession(key, pureKey, base64, json)
	} else {
		return getCookie(key, pureKey, base64, json)
	}
}

export const removeSessionAuto = (keys, pureKey = false) => {
	if (isSupportSessionStorage()) {
		removeSession(keys, pureKey)
	} else {
		removeCookie(keys, pureKey)
	}
}
// ==================== SessionStorage(Cookie) ====================


Vue.prototype.$storage = {
	isSupportLocalStorage,
	putStorage,
	getStorage,
	removeStorage,
	isSupportSessionStorage,
	putSession,
	getSession,
	removeSession,
	putCookie,
	getCookie,
	removeCookie,
	putStorageAuto,
	getStorageAuto,
	removeStorageAuto,
	putSessionAuto,
	getSessionAuto,
	removeSessionAuto,
	put: putStorageAuto,
	get: getStorageAuto,
	remove: removeStorageAuto
}
